export interface ITimeslot {
  time: string;
  timeStampIndex: number;
  selected: boolean;
}
export interface ITimeslots {
  list: ITimeslot[];
  filterList: ITimeslot[];
  Error: any;
  selected: ITimeslot;
  selectedDate: string;
}
export const initTimeslots: ITimeslots = {
  list: [],
  filterList: [],
  Error: null,
  selected: null,
  selectedDate: null,
};
